module.exports = __webpack_public_path__ + "img/centre1.7e74d049.png";